import React, {useEffect, useMemo, useState} from "react";
import {BoxRenderProps} from "@components/grid/BoxesGrid";
import BoxesDeleteModal from "@components/boxes-delete-modal";
import {useNavigate} from "react-router-dom";
import moment from "moment/moment";
import useSubscriptionType from "@hooks/useSubscriptionType";
import {useRefreshBoxFmvMutation} from "@mwServices/Boxes";
import {showResponse} from "@services/Api";
import MyCollectionBoxListItemDesktop from "@mwPages/my-collection/boxes/MyCollectionBoxListItemDesktop";
import MyCollectionBoxListItemMobile from "@mwPages/my-collection/boxes/MyCollectionBoxListItemMobile";
import {useWindowSize} from "@components/window-size-provider";

const MyCollectionBoxListItem = ({
    item,
    setEditBox,
    toggleSelected,
    isSelected,
    showEditMultiple,
    showDesktopView,
}: BoxRenderProps) => {
    const windowDimensions = useWindowSize();
    const box = item;
    const navigate = useNavigate();
    const [showRemoveBox, setShowRemoveBox] = useState(false);
    const [postRefreshFmv, refreshFmvResponse] = useRefreshBoxFmvMutation();

    const subscriptionType = useSubscriptionType();
    const showTotalFmv = useMemo(() => (subscriptionType.isStandard || subscriptionType.isTrial || subscriptionType.isUnlimited), [subscriptionType]);

    const fmvUpdated = useMemo(() => item && item.fmv_updated ? moment(item.fmv_updated).toDate() : null, [item]);

    useEffect(() => {
        showResponse(refreshFmvResponse, 'Box fmv refreshed.', 'Sorry, there was a problem refreshing the box FMV.');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refreshFmvResponse]);

    return (
        <>
            {showDesktopView ? (
                <MyCollectionBoxListItemDesktop
                    box={box}
                    showEditMultiple={showEditMultiple}
                    isSelected={isSelected}
                    toggleSelected={toggleSelected}
                    navigate={navigate}
                    showTotalFmv={showTotalFmv}
                    postRefreshFmv={postRefreshFmv}
                    refreshFmvResponse={refreshFmvResponse}
                    fmvUpdated={fmvUpdated}
                    setEditBox={setEditBox}
                    setShowRemoveBox={setShowRemoveBox}
                    windowDimensions={windowDimensions}
                />
            ) : (
                <MyCollectionBoxListItemMobile
                    box={box}
                    showEditMultiple={showEditMultiple}
                    isSelected={isSelected}
                    toggleSelected={toggleSelected}
                    navigate={navigate}
                    showTotalFmv={showTotalFmv}
                    postRefreshFmv={postRefreshFmv}
                    refreshFmvResponse={refreshFmvResponse}
                    fmvUpdated={fmvUpdated}
                    setEditBox={setEditBox}
                    setShowRemoveBox={setShowRemoveBox}
                />
            )}
            {showRemoveBox && (
                <BoxesDeleteModal box={box} isModalOpen={true} onCancel={() => setShowRemoveBox(false)} />
            )}
        </>
    );

};

export default MyCollectionBoxListItem;